import { HttpErrorResponse } from '@angular/common/http';

/** The HTTP status of a failed request; undefined for anything that is not an HTTP error. */
export function httpStatus(error: unknown) {
  if (!(error instanceof HttpErrorResponse)) return undefined;

  return error.status;
}

/** The `code` of the JSON error body (e.g. `OUT_OF_ENTRY_SCOPE`). */
export function errorCode(error: unknown) {
  const body = errorBody(error);

  if (!body || !('code' in body)) return undefined;

  return body.code;
}

/** The `message` of the JSON error body, when it is text. */
export function errorMessage(error: unknown) {
  const body = errorBody(error);

  if (!body || !('message' in body)) return undefined;
  if (typeof body.message !== 'string') return undefined;

  return body.message;
}

function errorBody(error: unknown) {
  if (!(error instanceof HttpErrorResponse)) return undefined;

  const body: unknown = error.error;

  if (typeof body !== 'object' || body === null) return undefined;

  return body;
}
